module.exports = __webpack_public_path__ + "img/广告-5 - 牛刀小试.a1cca8bc.jpg";